/**
 * ImagesLoaded + MatchHeight Initialization
 *
 * Waits for images in .col_post to load, then updates matchHeight
 */
(function($) {
    'use strict';

    function initMatchHeight() {
        // Apply matchHeight to post content boxes
        $('.single_post .post_content').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });
    }

    $(document).ready(function() {
        var $container = $('.col_post');

        if ($container.length && $.fn.imagesLoaded && $.fn.matchHeight) {
            // Initialize matchHeight on posts
            initMatchHeight();

            // Update after images load
            $container.imagesLoaded().progress(function() {
                $.fn.matchHeight._update();
            });
        }
    });

    // Re-initialize matchHeight after AJAX updates
    $(document).on('postsUpdated', function() {
        if ($.fn.matchHeight) {
            // Remove old matchHeight groups
            $.fn.matchHeight._groups.forEach(function(group) {
                group.elements.each(function() {
                    $(this).css('height', '');
                });
            });
            $.fn.matchHeight._groups = [];

            // Reinitialize
            initMatchHeight();

            // Update after images load
            var $container = $('.col_post');
            if ($container.length && $.fn.imagesLoaded) {
                $container.imagesLoaded().progress(function() {
                    $.fn.matchHeight._update();
                });
            }
        }
    });
})(jQuery);
